export const oneDay = 24 * 60 * 60 * 1000;
